import React from 'react';
import { Link } from 'gatsby';
import { Box, Flex, Text, Circle, Button, Heading as ChakraHeading } from '@chakra-ui/react';

import SEO from '@interness/web-core/src/components/modules/SEO/SEO';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';

const steps = [
  {
    title: 'Artikel auswählen',
    text: 'Stöbern Sie in unserem Mietbereich und legen Sie die gewünschten Artikel in die Mietanfrage. ' +
      'Wählen Sie dabei die gewünschte Menge – einen Mietzeitraum geben Sie im nächsten Schritt für die gesamte Anfrage an.',
  },
  {
    title: 'Anfrage senden',
    text: 'Geben Sie Ihren Mietzeitraum (Beginn und Ende) sowie Ihre Kontaktdaten an und senden Sie ' +
      'die unverbindliche Mietanfrage an uns ab. Es entstehen dabei noch keine Kosten.',
  },
  {
    title: 'Bestätigung erhalten',
    text: 'Sie erhalten umgehend eine automatische Eingangsbestätigung per E-Mail. Wir prüfen die ' +
      'Verfügbarkeit der Artikel und melden uns persönlich bei Ihnen, um den Mietzeitraum verbindlich zu bestätigen.',
  },
  {
    title: 'Abholen & bezahlen',
    text: 'Zum vereinbarten Termin holen Sie die Artikel bei uns im Geschäft ab. Die Bezahlung erfolgt ' +
      'bequem vor Ort bei der Abholung.',
  },
  {
    title: 'Zurückgeben',
    text: 'Am Ende Ihres Mietzeitraums bringen Sie die Artikel einfach wieder zu uns ins Geschäft zurück. ' +
      'Fertig – wir freuen uns auf Ihren nächsten Besuch.',
  },
];

function MietablaufPage() {
  return (
    <>
      <SEO title="Mietablauf" />
      <Wrapper>
        <Spacer />
        <Heading subtitle="In 5 einfachen Schritten zum Mietartikel">Mietablauf</Heading>
        <Spacer />
        <Box maxWidth="760px" margin="0 auto">
          <Text textAlign="center">
            Bei uns können Sie ausgewählte Artikel ganz unkompliziert mieten. So funktioniert es:
          </Text>
          <Spacer />
          {steps.map((step, index) => (
            <Flex key={step.title} mb={8} align="flex-start">
              <Circle
                size="48px"
                bg="brand.500"
                color="white"
                fontWeight="bold"
                fontSize="xl"
                flexShrink={0}
                mr={5}
              >
                {index + 1}
              </Circle>
              <Box>
                <ChakraHeading as="h2" size="md" mb={2}>
                  {step.title}
                </ChakraHeading>
                <Text>{step.text}</Text>
              </Box>
            </Flex>
          ))}
          <Spacer />
          <Box textAlign="center">
            <Button colorScheme="brand" as={Link} to="/shop/rent">
              Jetzt Mietartikel entdecken
            </Button>
          </Box>
          <Spacer />
          <Text textAlign="center" fontSize="sm" color="gray.500">
            Die Mietanfrage ist unverbindlich. Ein Mietvertrag kommt erst mit unserer Bestätigung
            und der Abholung im Geschäft zustande.
          </Text>
        </Box>
        <Spacer />
      </Wrapper>
    </>
  );
}

export default MietablaufPage;
